import { DatePipe } from '@angular/common'
import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { Footnote } from 'src/app/models/footnote.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

import { ProfileDashboardModel } from '../../../models/profile-response.model'
import { Dashboard } from '../dashboard.model'

@Component({
  selector: 'dashboard-stats',
  templateUrl: './dashboard-stats.component.html',
  styleUrls: ['./dashboard-stats.component.scss'],
  providers: [],
})
export class DashboardStatsComponent {
  @Input() dashboardModel: Dashboard
  @Input() profileDashboardModel: ProfileDashboardModel
  @Input() expenseRatioFootnote: Footnote
  @Input() yieldNote: any

  dialogTitle: string
  noteText: string
  isExternalETF: boolean
  fundDefinition = 'fund-definitions'
  @ViewChild('simpleDialogContent') simpleDialogContent: TemplateRef<any>
  public datePipe: DatePipe
  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {
    this.datePipe = new DatePipe('en-US')
  }

  public staticTicker: any[] = [
    'BNDX',
    'VTIP',
    'VIPSX',
    'VTAPX',
    'VGCIX',
    'VTABX',
    'VAIPX',
    'VIPIX',
    'VTSPX',
  ]
  public SecyieldFlag = false
  public noteUrl: string
  public days: string
  public tokens: string[]
  public token: any
  public staticTickerMap: any = {}
  aemContentSub: Subscription
  noteTextAem: AEMChunk
  secYield: string
  expenseRatio: string
  grossExpenseRatio: string
  netExpenseRatio: string

  get isMinimum(): boolean {
    return (!this.profileDashboardModel?.isClosed ||
      !this.profileDashboardModel?.isClosedToNewInvestors) &&
      this.dashboardModel?.minimum
      ? true
      : false
  }

  ngOnInit(): void {
    this.noteUrl = window.location.href.split('#')[0].concat('/sec-yield')
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
    this.isExternalETF =
      this.profileDashboardModel?.isETF &&
      this.profileDashboardModel?.isExternalFund
  }

  parseAEMContent(content) {
    this.staticTickerMap = {
      BNDX: this.centralContentService.getContentByBody(
        'fund_definitions_bndx',
        content,
      ),
      VTIP: this.centralContentService.getContentByBody(
        'fund_definitions_vtip',
        content,
      ),
      VIPSX: this.centralContentService.getContentByBody(
        'fund_definitions_vipsx',
        content,
      ),
      VTAPX: this.centralContentService.getContentByBody(
        'fund_definitions_vtapx',
        content,
      ),
      VGCIX: this.centralContentService.getContentByBody(
        'fund_definitions_vgcix',
        content,
      ),
      VTABX: this.centralContentService.getContentByBody(
        'fund_definitions_vtabx',
        content,
      ),
      VAIPX: this.centralContentService.getContentByBody(
        'fund_definitions_vaipx',
        content,
      ),
      VIPIX: this.centralContentService.getContentByBody(
        'fund_definitions_vipix',
        content,
      ),
      VTSPX: this.centralContentService.getContentByBody(
        'fund_definitions_vtspx',
        content,
      ),
    }
    this.secYield = this.centralContentService.getContentByBody(
      'fund_definitions_yield',
      content,
    ).contentValue
    this.expenseRatio = this.centralContentService.getContentByBody(
      'fund_definitions_expense_ratio',
      content,
    ).contentValue
    this.grossExpenseRatio = this.centralContentService.getContentByBody(
      'fund_definitions_mf_non_vg_gross_expense_ratio',
      content,
    ).contentValue
    this.netExpenseRatio = this.centralContentService.getContentByBody(
      'fund_definitions_mf_non_vg_net_expense_ratio',
      content,
    ).contentValue
  }
  // eslint-disable-next-line complexity,max-statements
  public setDialogInfo(title = '', noteText = '', noteCode = '') {
    this.dialogTitle = title
    this.noteText = noteCode.concat('-').concat(noteText)
    if (this.dialogTitle === 'Market price') {
      this.noteText = this.dashboardModel?.closingMarketPrice
    }
    if (this.dialogTitle === 'SEC yield') {
      this.SecyieldFlag = true
      this.noteText = this.secYield
    }
    if (this.dialogTitle === 'Expense Ratio') {
      this.noteText = this.expenseRatio
    }
    if (this.dialogTitle === 'Gross Expense Ratio') {
      this.noteText = this.grossExpenseRatio
    }
    if (this.dialogTitle === 'Net Expense Ratio') {
      this.noteText = this.netExpenseRatio
    }
    if (this.staticTickerMap[noteText]) {
      this.noteTextAem = this.staticTickerMap[noteText]
      this.noteText = this.noteTextAem.contentValue
    }
    //openDialog
  }
  // eslint-disable-next-line complexity
  public createDaysToken(yieldNote: any) {
    let dayToken
    if (yieldNote !== null && yieldNote !== undefined) {
      for (const note of yieldNote) {
        if (note.footnoteText !== undefined) {
          this.days = note.footnoteText
          this.tokens = this.days.split(' ')
          for (const value of this.tokens) {
            this.token = value.trim()
            if (this.isValidToken()) {
              dayToken = this.token + ' day'
            }
          }
        }
      }
    }
    return dayToken
  }

  isValidToken() {
    return !isNaN(this.token) && this.token.length > 0
  }

  public expandNavAccordion() {
    const innerWidth = window.innerWidth
    const performanceFeeAccordion = document.getElementById(
      'performance-and-fees-accordion',
    )
    const performanceFeeAccordionBody =
      document.getElementById('performance-body')
    const num = 992

    if (innerWidth <= num) {
      if (
        performanceFeeAccordionBody.getAttribute('class') ===
        'c11n-accordion__body'
      ) {
        performanceFeeAccordion.click()
      }
    }
  }

  public scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    return false
  }

  expandAndRedirect(id: string) {
    this.expandNavAccordion()
    this.scrollTo(id)
  }
}
